import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Form, Field, Formik, ErrorMessage } from "formik";
import * as yup from "yup";

const NotifyCreater = ({
  editItemId,
  editItemValue,
  close,
  text,
  description,
  handleSubmit,
  buttonText,
  placeholder,
  inputName
}) => {
  return (
    <Fragment>
      <div className="modalTable_header">
        {text}
        <div className="close_icon" onClick={close} />
      </div>
        <Formik
          initialValues={{
            [inputName]: editItemValue
          }}
          onSubmit={value => {
            handleSubmit({ id: editItemId, value: value[inputName] });
            close();
          }}
        >
          {() => (
            <Form className="modalTable_content">
              <div className="modalTable_description">Hi there, it looks like the short link you just used to get here expired. Would you like us to send the creator of this link a message requesting reactivation? If yes, what is your email address?</div>

              {editItemValue !== undefined && (
                <div className="modalTable_input_wrap">
                  <Field
                    type="text"
                    placeholder={placeholder}
                    name={inputName}
                    className="input-default"
                  />
                  <ErrorMessage
                    name={inputName}
                    render={msg => <div className="error_input">{msg}</div>}
                  ></ErrorMessage>
                </div>
              )}
              <button className="btn default" type="submit">
                {buttonText}
              </button>
            </Form>
          )}
        </Formik>
    </Fragment>
  );
};
const Validation = inputName => {
  if (inputName === "url") {
    return yup.object().shape({
      url: yup
        .string()
        .required()
        .matches(
          // eslint-disable-next-line
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
          "the url is incorrect"
        )
        .min(2)
    });
  }
  
  if (inputName === "email") {
    return yup.object().shape({
      email: yup
        .string()
        .email('Invalid email')
        .required('Enter your email'),
    });
  }
  
  return yup.object().shape({
    [inputName]: yup
      .string()
      .required()
      .min(2)
  });
};

NotifyCreater.propTypes = {
  editItem: PropTypes.object,
  close: PropTypes.func,
  placeholder: PropTypes.string,
  inputName: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleReduceSubmit: PropTypes.func,
  buttonText: PropTypes.string
};

export default NotifyCreater;